import {
  environment,
  prod
} from '../../../solaris-lens-common-lib/src/constants/endpoints';

const USE_LOCAL_EXTERNAL_APPS = false;

export const getExternalEnvPrefix = () =>
  environment === prod ? '' : environment;

export const getExternalAppUrl = (host, localhost) => {
  if (USE_LOCAL_EXTERNAL_APPS && localhost) {
    return localhost;
  }

  if (!host) {
    return '';
  }

  return `https://${getExternalEnvPrefix()}${host}`;
};
